var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.hasSupport)?_c('v-btn',{attrs:{"icon":"","color":_vm.showDialog ? 'green' : 'default'},on:{"click":_vm.click}},[_c('v-icon',[_vm._v("mdi-face-agent")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }